export function currentUnixSeconds() {
  return Math.floor(Date.now() / 1000);
}

/**
 * Normalize a server `server_time` (epoch seconds, epoch millis, or {unix})
 * into epoch seconds. Countdowns should run on (device + serverOffset) so a
 * phone with a wrong clock or a non-Brazil timezone still shows correct time.
 */
export function serverEpochSeconds(value?: number | { unix?: number } | null) {
  const raw = typeof value === 'number' ? value : Number(value?.unix || 0);
  if (!raw) return 0;
  return raw > 1_000_000_000_000 ? Math.floor(raw / 1000) : Math.floor(raw);
}

export function raffleSecondsRemaining(scheduledAt: number | undefined, nowSeconds: number) {
  return Math.max(0, Math.floor(Number(scheduledAt || 0) - nowSeconds));
}

/**
 * A countdown that cannot be misread as a clock time.
 *
 * This used to render `mm:ss` — so a draw scheduled for 07:00 with ten minutes
 * to go showed "10:24" right next to the literal time "07:00", and players read
 * it as "twenty-four past ten". Units make the difference unambiguous, and the
 * digits stay monospace-friendly (zero-padded seconds/minutes).
 *
 *   93_000s → "1d 01h"   ·   5_461s → "1h 31m"   ·   624s → "10m 24s"   ·   11s → "11s"
 */
export function formatRaffleCountdown(scheduledAt: number | undefined, nowSeconds: number) {
  const seconds = raffleSecondsRemaining(scheduledAt, nowSeconds);
  const pad = (value: number) => String(value).padStart(2, '0');
  const days = Math.floor(seconds / 86_400);
  const hours = Math.floor((seconds % 86_400) / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;
  if (days > 0) return `${days}d ${pad(hours)}h`;
  if (hours > 0) return `${hours}h ${pad(minutes)}m`;
  if (minutes > 0) return `${minutes}m ${pad(secs)}s`;
  return `${secs}s`;
}
